export { default } from "./ServicesPrivilegeList-component";
